export { useDrillPageKeyboardAwareContentStyle } from "#use-drill-page-keyboard-aware-content-style";
